import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import State from '../states/State';
import slice from '../states/dialog/slice';
import shellSlice from '../states/shell/slice';
import dialogSlice from '../states/dialog/slice';
import { change } from 'redux-form';
import useStyles from '../styles/styles';

const formName = 'battery-form';

type PeDialogProps = {};

const PeDialog: React.FC<PeDialogProps> = props => {
  const classes = useStyles();

  const state = useSelector((state: State) => ({
    dialog: state.dialog,
    leadData: state.shell.leadData
  }));
  const { isOpen, title, message, name } = state.dialog;

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(slice.actions.updateDialog(false));
  };

  const handleUseEmail = () => {
    if (state.leadData) {
      const { first_name, last_name, mobile_phone_c } = state.leadData;
      // set current value to field
      dispatch(change(formName, 'first_name', first_name));
      dispatch(change(formName, 'last_name', last_name));
      dispatch(change(formName, 'phone_number', mobile_phone_c));
      // set useDataLead = true
      dispatch(shellSlice.actions.updateUseDataLead(true));
      // set scroll target
      dispatch(shellSlice.actions.updateScrollTarget("personal_info"));
      // clean email-confirm when using email lead
      dispatch(dialogSlice.actions.updateDialogInfo({ message: '', title: '', name: '' }));
    }
    // close dialog
    handleClose();
  };

  const handleNotUseEmail = () => {
    // Clear value FN, LN, PN, Email
    dispatch(change(formName, 'first_name', ''));
    dispatch(change(formName, 'last_name', ''));
    dispatch(change(formName, 'phone_number', ''));
    dispatch(change(formName, 'your_email', ''));
    // clean email-confirm when using lead
    dispatch(dialogSlice.actions.updateDialogInfo({ message: '', title: '', name: '' }));
    // close dialog
    handleClose();
  };

  const renderButton = () => {
    switch (name) {
      case 'email-confirm':
        return (
          <div>
            <Button className={classes.button} variant="contained" autoFocus onClick={handleUseEmail} color="primary">
              Use this info
            </Button>
            <Button className={classes.button} variant="contained" autoFocus onClick={handleNotUseEmail} color="primary">
              Create new
            </Button>
          </div>
        );
      default:
        return (
          <Button className={classes.button} variant="contained" autoFocus onClick={handleClose} color="primary">
            Close
          </Button>
        );
    }
  };

  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="responsive-dialog-title" className={classes.PeDialog_header}>
          {title}
        </DialogTitle>
        <DialogContent className={classes.PeDialog_content}>
          <DialogContentText style={{ whiteSpace: 'pre-line', fontSize: '15px' }}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{renderButton()}</DialogActions>
      </Dialog>
    </div>
  );
};

export default PeDialog;
